import type { FpMessagePart } from "../../../../../../schemas/codegen";

/**
 * Hacky utility to try to extract the string "content" prop from a tool call part's result
 */
export const getBootsmanResultContent = (
  part: Extract<FpMessagePart, { type: "tool-call" }>,
): string | null => {
  const content = (part.result as { data: { content: unknown } } | undefined)
    ?.data?.content;

  if (typeof content !== "string") {
    return null;
  }

  return content;
};
